// src/schedule/components/EventActionsMenu.jsx
import React from 'react';
import { MdColorLens, MdContentCopy, MdPeople, MdNoteAdd } from 'react-icons/md';

/**
 * Menu akcji dla eventu (kolor, kopiuj, potrzebni, notatka)
 */
export default function EventActionsMenu({
    open,
    hasNote,
    onColorClick,
    onCopyClick,
    onNeededClick,
    onNoteClick,
    menuRef
}) {
    if (!open) return null;

    return (
        <div
            ref={menuRef}
            className="absolute right-0 mt-1 p-2 flex gap-3 text-xl rounded shadow-lg border
                       bg-white text-gray-900 border-gray-200
                       dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700"
            onClick={(e) => e.stopPropagation()}
            style={{ zIndex: 2147483648 }} // Wyższy niż powiększona karta
        >
            <button
                type="button"
                className="cursor-pointer hover:text-yellow-600 dark:hover:text-yellow-400"
                title="Kolor"
                onClick={(e) => {
                    e.stopPropagation();
                    onColorClick();
                }}
            >
                <MdColorLens />
            </button>

            <button
                type="button"
                className="cursor-pointer hover:text-yellow-600 dark:hover:text-yellow-400"
                title="Kopiuj skład na inne dni tego wydarzenia"
                onClick={(e) => {
                    e.stopPropagation();
                    onCopyClick();
                }}
            >
                <MdContentCopy />
            </button>

            <button
                type="button"
                className="cursor-pointer hover:text-yellow-600 dark:hover:text-yellow-400"
                title="Potrzebni"
                data-testid="needed-button"
                onClick={(e) => {
                    e.stopPropagation();
                    onNeededClick();
                }}
            >
                <MdPeople />
            </button>

            <button
                type="button"
                className={`cursor-pointer hover:text-yellow-600 dark:hover:text-yellow-400 relative ${hasNote ? 'text-red-500 dark:text-red-400' : ''}`}
                title={hasNote ? 'Edytuj notatkę (istnieje)' : 'Dodaj notatkę'}
                onClick={(e) => {
                    e.stopPropagation();
                    onNoteClick();
                }}
            >
                <MdNoteAdd />
                {hasNote && <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></span>}
            </button>
        </div>
    );
}

